import { render, staticRenderFns } from "./TripMovementContainer.vue?vue&type=template&id=70c3d804&scoped=true&lang=pug"
import script from "./TripMovementContainer.vue?vue&type=script&lang=js"
export * from "./TripMovementContainer.vue?vue&type=script&lang=js"
import style0 from "./TripMovementContainer.vue?vue&type=style&index=0&id=70c3d804&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c3d804",
  null
  
)

export default component.exports